/******/ (() => { // webpackBootstrap
	/*!**************************!*\
	  !*** ./src/js/loader_old.js ***!
	  \**************************/
	(function () {
		if (window.lightHouse) return;
		let loader = null;
		let loaderFigure = null;
		function readCookie(name) {
			if (typeof window.getCookie === "function") {
				return window.getCookie(name);
			}
			const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
			const matches = document.cookie.match(new RegExp("(?:^|; )" + escapedName + "=([^;]*)"));
			return matches ? decodeURIComponent(matches[1]) : undefined;
		}
		const isLoader = readCookie("loader");
		const loaderAlwaysOn = Boolean(window.loaderAlwaysOn);
		const LOADER_DELAY_MS = 150;
		const LOADER_JSON = Array.isArray(window.loaderConfig) && window.loaderConfig.length ? window.loaderConfig[0] : null;
		let _loaderAnim = null;
		const figureWidth = window.matchMedia("(min-width: 1200px)").matches ? window.innerHeight * 0.80049 : window.innerHeight * 0.59113;
		const figureWidthPercent = figureWidth * 100 / window.innerWidth / 2;
		const figurePos = 100 + figureWidthPercent;
		const figurePosStart = -figureWidth / 2;
		const figurePosEnd = figurePosStart + window.innerWidth;
		function waitForLottie(callback, timeout = 5000) {
			const startTime = Date.now();
			function check() {
				if (window.lottie) {
					callback(true);
				} else if (Date.now() - startTime >= timeout) {
					console.warn("Lottie library failed to load");
					callback(false);
				} else {
					setTimeout(check, 50);
				}
			}
			check();
		}
		function loadLoaderFigure() {
			if (!window.lottie) {
				hideLoader();
				return;
			}
			if (!LOADER_JSON) {
				hideLoader();
				if (!loaderAlwaysOn) setLoaderCookie();
				return;
			}
			const currentJson = LOADER_JSON;
			if (_loaderAnim) {
				try {
					_loaderAnim.destroy();
				} catch (e) { }
			}
			loaderFigure.innerHTML = "";
			const startX = currentJson.direction === "left" ? `${figurePosStart}px` : `${figurePosEnd}px`;
			loaderFigure.style.transform = `translateX(${startX})`;
			loaderFigure.style.transition = "none";
			_loaderAnim = lottie.loadAnimation({
				container: loaderFigure,
				renderer: "svg",
				loop: false,
				autoplay: false,
				path: currentJson.path
			});
			_loaderAnim.addEventListener("DOMLoaded", () => {
				_loaderAnim.setSpeed(1 / currentJson.time);
				const duration = _loaderAnim.getDuration() * currentJson.time;
				const endX = currentJson.direction === "left" ? `${figurePosEnd}px` : `${figurePosStart}px`;
				loaderFigure.style.transition = `transform ${duration}s linear`;
				setTimeout(() => {
					loaderFigure.style.transform = `translateX(${endX})`;
					_loaderAnim.play();
				}, 10);
			});
			_loaderAnim.addEventListener("complete", () => {
				hideLoader();
				if (!loaderAlwaysOn) setLoaderCookie();
			});
		}
		function hideLoader() {
			document.body.classList.remove("no-scroll");
			if (loader) loader.classList.remove("show");
			if (loaderFigure) {
				loaderFigure.style.transform = "";
				loaderFigure.style.transition = "";
			}
		}
		function setLoaderCookie() {
			const date = new Date(Date.now() + 86400e3);
			document.cookie = "loader=true; path=/; expires=" + date;
		}
		function startLoaderIfNeeded() {
			loader = document.querySelector(".loader");
			loaderFigure = document.querySelector(".loader-figure");
			if (!loader || !loaderFigure) return;
			if (!loaderAlwaysOn && isLoader && isLoader !== "undefined") return;
			document.body.classList.add("no-scroll");
			loader.classList.add("show");
			waitForLottie(loaded => {
				if (loaded) {
					setTimeout(() => loadLoaderFigure(), LOADER_DELAY_MS);
				} else {
					// Якщо Lottie не завантажився, просто ховаємо лоадер
					setTimeout(hideLoader, LOADER_DELAY_MS);
				}
			});
		}
		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", startLoaderIfNeeded, {
				once: true
			});
		} else {
			startLoaderIfNeeded();
		}
	})();
	/******/
})()
;